import React from "react";
import { Save, Download } from "lucide-react";

interface HeaderProps {
  onSave: () => void;
  onExport: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onSave, onExport }) => (
  <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
    <div className="flex items-center space-x-3">
      <div className="w-8 h-8 bg-blue-500 rounded flex items-center justify-center">
        <span className="text-white font-bold text-sm">J</span>
      </div>
      <div>
        <h1 className="text-lg font-semibold text-gray-900">
          CPaaS Journey Builder
        </h1>
      </div>
    </div>
    <div className="flex items-center space-x-3">
      <button
        onClick={onSave}
        className="flex items-center space-x-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        <Save className="w-4 h-4" />
        <span>Save</span>
      </button>
      <button
        onClick={onExport}
        className="flex items-center space-x-2 px-3 py-2 text-gray-700 hover:text-gray-900"
      >
        <Download className="w-4 h-4" />
        <span>Export JSON</span>
      </button>
    </div>
  </div>
);